import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';

import router from './router';
import store from './store';

// Styles
import '@/scss/style.scss';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
// Plugins
import vuetify from '@/plugins/vuetify';
import { QuillEditor } from '@vueup/vue-quill';

const app = createApp(App);
app.component('QuillEditor', QuillEditor);

app.config.globalProperties.$store = store;

app.use(store).use(vuetify).use(router).mount('#app');
